import { parseNumberByPrecision } from './parseNumberByPrecision.js';

var abbreviateNumber = function (number) {
    if (number < 1000) {
        return number;
    }
    if (!(number % 1000)) {
        return number / 1000 + 'K';
    }
    if (+parseNumberByPrecision(1, number / 1000, 1) === +number / 1000) {
        return number / 1000 + 'K';
    }
    return parseNumberByPrecision(1, number / 1000, 1) + 'K' + '+';
};
var abbreviateNumberTwo = function (num) {
    var intlFormat = function (num) {
        return new Intl.NumberFormat().format(Math.round(num * 10) / 10);
    };
    if (num >= 1000000)
        return intlFormat(num / 1000000) + 'M';
    if (num >= 1000)
        return intlFormat(num / 1000) + 'k';
    return num;
};

export { abbreviateNumber, abbreviateNumberTwo };
